
export enum ViewMode {
  Search = 'SEARCH',
  Read = 'READ',
  New = 'NEW',
  Edit = 'EDIT',
  Delete = 'DELETE',
}
